import React from "react";
import { Outlet } from "react-router-dom";
import PayrollSidebar from "./PayrollSidebar";
import PayrollTopbar from "./components/PayrollTopbar";
import "./payroll.css";

export default function PayrollLayout() {
  return (
    <div className="payroll-shell">
      <PayrollSidebar />
      <div className="payroll-main">
        <PayrollTopbar />
        <div className="payroll-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
